import { Breadcrumbs, Text } from "@mantine/core";

import { InvoiceDetail } from "../../../../types/invoice/invoice.ts";
import { toHumanReadable } from "../../../../utils/string.ts";

interface InvoiceBreadcrumbsProps {
  invoice: InvoiceDetail;
  onBreadcrumbsClick?: () => void;
}

const InvoiceBreadcrumbs = ({
  invoice,
  onBreadcrumbsClick,
}: InvoiceBreadcrumbsProps) => {
  const items = [
    { title: "Invoices", onClick: onBreadcrumbsClick },
    {
      title: `${invoice?.invoiceNumber} — ${toHumanReadable(
        invoice?.paymentStatus
      )}`,
    },
  ];

  return (
    <Breadcrumbs>
      {items.map((item, index) => (
        <Text key={index} onClick={item.onClick}>
          {item.title}
        </Text>
      ))}
    </Breadcrumbs>
  );
};

export default InvoiceBreadcrumbs;
